const searchInput = document.querySelector('.search-form__input input');

if (searchInput) {
  const searchForm = searchInput.closest('.search-form');

  const toggleSearchClass = () => {
    searchForm.classList.toggle('has-value', searchInput.value.length > 0);
  };

  toggleSearchClass();
  searchInput.addEventListener('input', toggleSearchClass);
}
